import React from 'react';
export function Footer() {
  return <footer className="w-full bg-plum-deep" data-id="element-90" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-91" data-mp="3gezeh7brdx2q">
        <h3 className="font-display text-2xl font-semibold uppercase text-gold" data-id="element-92" data-mp="3ghc2o28413o8">
          Wrestling Practice <span className="text-white" data-id="element-93" data-mp="32lrm3dfusxjz">Ready</span>
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-94" data-mp="36qhdaozkhnyk">
          The Two-Track Practice System — because planning practice shouldn&apos;t
          cost you every night of the season.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-white/70" data-id="element-95" data-mp="387czflhuzc3">
          {/* TODO: confirm the support email for this product */}
          <a href="mailto:help@iclcollective.com" className="hover:text-white hover:underline" data-id="element-96" data-mp="3qcniknv98gxk">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-plum-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-97" data-mp="2eyt9iquuu9rc">
          Wrestling Practice Ready is a planning resource for coaches. It does
          not replace the rules of your state or national association, the
          judgment of your athletic trainer or physician, or coach
          certification. Follow your association&apos;s protocols for skin checks
          and concussions. It contains no weight-management content. Not
          affiliated with any wrestling organization, association or program.
          No competitive results are promised. © 2026 Wrestling Practice Ready
          — All rights reserved.
        </p>
      </div>
    </footer>;
}